<div [ngStyle]="{'width': width, 'height':  height || ''}">

    <div class="card shadow-sm" style="height: 100%;" >
      <div class="card-title turbine-title-header ml-3 mr-3 mb-2 mt-2" >
        <ul class="nav" style="display: flex;">
          <li class="nav-item spacer">
            <div>
              <ng-content select="app-card-header"></ng-content>
            </div>
          </li>
        </ul>
      </div>
      <ng-content select="app-card-body"></ng-content>
    </div>
</div>
